<template>
    <div>
        <roles-form-with-data :isEdit="isEdit" :id="id" ref="form" @submitLoad="submitLoad"></roles-form-with-data>
        <!-- <div class="button-div">
            <el-button type="primary" @click="addRoles" :loading="submitLoading">提交</el-button>
            <el-button type="primary" plain>取消</el-button>
        </div> -->
    </div>
</template>
<script>
import rolesFormWithData from './withData'
export default {
  components: {
    rolesFormWithData
  },
  computed: {
    form () {
      return this.$refs.form
    }
  },
  props: {
    isEdit: {
      type: Boolean,
      default: false
    },
    id: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      submitLoading: false
    }
  },
  methods: {
    addRoles () {
      this.form.submit()
    },
    submitLoad (val) {
      this.submitLoading = val
    }
  }
}
</script>
<style lang="less">

</style>
